import { render, staticRenderFns } from "./bomCommentCard.vue?vue&type=template&id=9f157256&scoped=true&"
import script from "./bomCommentCard.vue?vue&type=script&lang=js&"
export * from "./bomCommentCard.vue?vue&type=script&lang=js&"
import style0 from "./bomCommentCard.vue?vue&type=style&index=0&id=9f157256&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f157256",
  null
  
)

export default component.exports